import { MutableRefObject, useEffect, useState } from "react";

export const useInterSectionObserver = <T extends HTMLElement | null>(ref: MutableRefObject<T>) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const callBack: IntersectionObserverCallback = (entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                setIsIntersecting(true);
            });
        };

        const options = {};

        const observer = new IntersectionObserver(callBack, options);

        observer.observe(element);

        return () => {
            observer.unobserve(element);
        };
    }, [ref.current]);

    return isIntersecting;
};
